<div class="modal-content modal-xl">
    <div class="modal-header">
        <div class="col-md-12">
            <span [innerHTML]="title"></span>
        </div>



    </div>
    <div class="row modal-body" style="padding: 50px;">
        <span [innerHTML]="message"></span>
    </div>
    <div class="model-footer">
        <div
            style="display: flex; justify-content: space-between; align-items: center;padding: 10px;border-top: 1px solid lightgray;">
            <button type="button" class="el-btn" (click)="decline()">{{ btnCancelText }}</button>
            <button type="button" class="el-btn" (click)="accept()">{{ btnOkText }}</button>
        </div>
    </div>
</div>